import { Badge, Box, Checkbox, IconButton, makeStyles } from "@material-ui/core";
import { ChevronDownIcon } from "../../../../icons";
import { Color } from "../../../../theme";
import { transparentize } from "polished";
import { GroupBase, OptionProps, components } from "react-select5";

export function CheckboxOptionCollapsibleComponent<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>
>(
  props: OptionProps<Option, IsMulti, Group> & {
    onCollapse: (option: Option) => void;
    isCollapsible: (option: Option) => boolean;
    isCollapsed: (option: Option) => boolean;
    isOptionStandAlone?: (option: Option) => boolean;
    isShowCollapsibleOptionBadge?: (props: Option) => boolean;
    isIndeterminate?: (props: Option) => boolean;
  }
) {
  const classes = useStyles();
  const { children, ...rest } = props;

  if (!children) return;

  const isCollapsible =
    props.isCollapsible(props.data) && !props?.isOptionStandAlone?.(props.data);

  const showBadge =
    props.isCollapsible(props.data) && props.isShowCollapsibleOptionBadge?.(props.data);

  const indeterminate = (props.isIndeterminate?.(props.data) && isCollapsible) ?? false;

  return (
    <div>
      <components.Option {...rest}>
        <Box className={classes.root}>
          <Box>
            <Badge color="primary" variant="dot" invisible={!showBadge}>
              <Checkbox
                indeterminate={indeterminate && !props.isSelected}
                style={{
                  padding: "0rem",
                  marginRight: "0.5rem",
                  paddingLeft:
                    props.isCollapsible(props.data) ||
                    props?.isOptionStandAlone?.(props.data)
                      ? "0rem"
                      : "0.5rem"
                }}
                checked={props.isSelected}
              />
              {props.children}
            </Badge>
          </Box>
          {isCollapsible && (
            <Box>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  props.onCollapse(props.data);
                }}
                className={classes.iconButton}
              >
                <ChevronDownIcon
                  style={{
                    width: "1rem",
                    height: "1rem",
                    transform: props.isCollapsed(props.data)
                      ? "rotate(0deg)"
                      : "rotate(-180deg)",
                    transition: "0.2s ease",
                    fill: props.selectProps.isDisabled
                      ? transparentize(0.5, Color.Body)
                      : Color.Body,
                    stroke: props.selectProps.isDisabled
                      ? transparentize(0.5, Color.Body)
                      : Color.Body
                  }}
                />
              </IconButton>
            </Box>
          )}
        </Box>
      </components.Option>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.5rem",
    whiteSpace: "nowrap"
  },
  iconButton: {
    padding: "0.25rem"
  }
}));
